import React, { useState ,useEffect } from "react";
import PageBanner from "../components/PageBanner";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Col, Row } from "antd";
import { FaTimes } from "react-icons/fa";

const CAWI = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  const [toggle, setToggle] = useState();
  const [toggle1, setToggle1] = useState();

  const handletoggle = () => {
    setToggle(!toggle);
  };
  const handletoggle1 = () => {
    setToggle1(!toggle1);
  };

  const cancletoggle = () => {
    setToggle(false);
    setToggle1(false);
  };

  const bannerData = {
    image: "/images/services/cawi-banner.jpg",
    heading: "Computer-assisted web interviewing",
    para: "Explore the world of market research and online surveys at Poll Sphere, where we harness the power of computer-assisted web interviewing to unlock valuable consumer insights",
  };
  return (
    <div className="page-content">
    <Helmet>
        <title>CAWI Solutions - Streamlined Online Surveys | Poll Sphere</title>
        <meta name="description" content="Unlock efficient market research with Poll Sphere's CAWI services. Harness user-friendly online surveys to gather insightful data quickly and accurately. Ideal for capturing dynamic consumer feedback and market trends." />
        </Helmet>
<PageBanner {...bannerData}/>
     

      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">
            <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/Cawi.jpg" alt="" />
              </div>
            </Col>
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> What is computer-assisted web interviewing (CAWI)</h2>
                <p>
                  CAWI is a sophisticated data collection method that combines
                  traditional survey techniques with cutting-edge technology. It
                  involves administering surveys and questionnaires to
                  respondents via the internet, allowing for remote
                  participation at the convenience of the respondents. Through
                  web-based platforms, CAWI enables researchers to gather
                  quantitative and qualitative data efficiently and accurately.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section>
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/how-work.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> How Does CAWI Work?</h2>
                    <p>
                      {" "}
                      <strong>Survey Design:</strong>
                      The journey begins with crafting a well-structured survey
                      instrument. Researchers create questions, response
                      options, and design the survey flow, ensuring that it
                      aligns with the research objectives.
                    </p>

                    <div
                      className={
                        toggle
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> How Does CAWI Work?</h2>
                          <p>
                            {" "}
                            <strong>Survey Design : </strong>
                            The journey begins with crafting a well-structured
                            survey instrument. Researchers create questions,
                            response options, and design the survey flow,
                            ensuring that it aligns with the research
                            objectives.
                          </p>
                          <p>
                            {" "}
                            <strong>Online Deployment : </strong>
                            Once the survey is ready, it's uploaded to an online
                            platform. Respondents receive invitations via email,
                            social media, or other online channels, guiding them
                            to the survey.
                          </p>
                          <p>
                            {" "}
                            <strong>Data Collection : </strong>
                            Respondents access the survey through their web
                            browsers, providing responses to the questions
                            presented. CAWI systems are designed to be
                            user-friendly, ensuring a smooth respondent
                            experience.
                          </p>
                          <p>
                            {" "}
                            <strong>Real-time Data Capture : </strong>
                            The journey begins with crafting a well-structured
                            survey instrument. Researchers create questions,
                            response options, and design the survey flow,
                            ensuring that it aligns with the research
                            objectives.
                          </p>
                          <p>
                            {" "}
                            <strong>Data Analysis : </strong>
                            Researchers can access the collected data through
                            secure online portals. Advanced analytical tools
                            help uncover insights, patterns, and trends within
                            the dataset.
                          </p>
                        </div>
                      </div>
                    </div>

                    <button onClick={handletoggle} className="btn btn-white">
                      {" "}
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <section className="py-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/benefits.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> Benefits of CAWI</h2>
                    <p>
                      {" "}
                      <strong>Cost-Effective : </strong>
                      CAWI significantly reduces costs associated with data
                      collection, printing, and postage. There's no need for
                      physical surveys or extensive fieldwork.
                    </p>
                    <div
                      className={
                        toggle1
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> Benefits of CAWI</h2>
                          <p>
                            {" "}
                            <strong>Cost-Effective : </strong>
                            CAWI significantly reduces costs associated with
                            data collection, printing, and postage. There's no
                            need for physical surveys or extensive fieldwork.
                          </p>

                          <p>
                            {" "}
                            <strong>Wide Reach : </strong>
                            CAWI transcends geographical boundaries, allowing
                            researchers to reach a global audience without
                            logistical constraints.
                          </p>
                          <p>
                            {" "}
                            <strong>Real-time Feedback : </strong>
                            Researchers receive real-time feedback, enabling
                            them to make quick adjustments to the survey or
                            research approach.
                          </p>
                          <p>
                            {" "}
                            <strong>Data Accuracy : </strong>
                            The digital nature of CAWI reduces errors in data
                            entry and transcription, ensuring high-quality data.
                          </p>
                          <p>
                            {" "}
                            <strong>Customization : </strong>
                            Surveys can be customized to match the branding and
                            objectives of the research, enhancing respondent
                            engagement.
                          </p>

                          <p>
                            <strong>Data Security : </strong>
                            CAWI platforms prioritize data security and
                            confidentiality, safeguarding sensitive information.
                          </p>
                        </div>
                      </div>
                    </div>
                    <button onClick={handletoggle1} className="btn btn-white">
                      {" "}
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CAWI;
